import React from 'react';
import './CTA.css';
import Button from  '../../components/Button/Button'

export default function CTA() {
  return (
    <div>
      <div className="cta">
        <div className="container">
          <div className="cta-content" data-aos="zoom-in">
            <h2 className="cta-title header-1">Ready to Transform Your Digital Presence?</h2>
            <p className="cta-text text-1">
              Let's discuss how our team can help you achieve your business goals.
            </p>
            <div className="cta-btn">
              <Button variant="primary" text="Book a consultation now" url="/contact" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
